import React from 'react';
import styles from './Tooltip.css';

function Tooltip(props) {
  const {
    tooltipProps,
    closeProps,
    backProps,
    primaryProps,
    index,
    step,
    isLastStep,
    size,
  } = props;
  const { locale } = step;

  return (
    <div {...tooltipProps} className={styles.container}>
      <a {...closeProps} type="button" className={styles.closeButton}>
        &times;
      </a>
      <div className={styles.body}>
        {step.title && (
          <div className={styles.header}>
            <b>{step.title}</b>
          </div>
        )}
        <br />
        {step.content && <div className={styles.content}>{step.content}</div>}
      </div>
      <div className={styles.footer}>
        <span>
          {index + 1}/{size}
        </span>
        <div className={styles.footerButtons}>
          {index > 0 && (
            <div className={styles['back-button']} {...backProps}>
              {step.locale.back}
            </div>
          )}
          <button className="btn btn-primary" {...primaryProps}>
            {isLastStep ? locale.close : locale.next}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Tooltip;
